import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import backIcon from '../../images/arrow_left.png';
import logo from '../../images/logo.png';
import userLogout from '../../images/user_logout.png';
import userProfile from '../../images/user_profile.png';
import { updateLanguage } from '../../localization/LocalizedString';
import './Navbar.css';

class Navbar extends React.Component {
  changeLanguage = (e, lang) => {
    e.preventDefault();
    updateLanguage(lang);
  };

  createTopBar = () => {
    const { translate } = this.props;
    const {
      session: {
        isAuthenticated = false,
      },
      blankReload,
    } = this.props;

    const brand = (
      <div className="col-md-3 col-xs-6">
        <Link to="/" className="navbar-item-flex" onClick={() => blankReload()}>
          <img className="navbar-logo" src={logo} alt="Posti logo" />
          <span className="navbar-logo-text">{translate('title')}</span>
        </Link>
      </div>
    );

    const navigation = [
      this.functionality(),
      this.userInfo(),
      this.languageDropDown(),
    ];

    return (
      <nav className="navbar-top">
        <div className="container">
          <div className="row">
            {brand}
            {!!isAuthenticated && navigation}
          </div>
        </div>
      </nav>
    );
  };

  functionality = () => {
    const { translate } = this.props;
    const {
      session: {
        isSubcontractor = false,
        isAdmin = false,
      },
    } = this.props;
    return (
      <div key="navigation-pages" className="col-md-5 col-xs-6">
        <div className="dropdown">
          <div className="navbar-item-inline navbar-nav-item drop-button text-3">
            <Link to="/">{translate('navigation.destinations')}</Link>
            &nbsp;
            {!!isAdmin && (<i className="fa fa-chevron-down" />)}
          </div>
          <div className="dropdown-content">
            {!!isAdmin && (<Link to="/deviations">{translate('navigation.deviations')}</Link>)}
          </div>
        </div>

        {!!isSubcontractor || !!isAdmin ? (
          <div className="dropdown">
            <div className="navbar-item-inline navbar-nav-item drop-button text-3">
              {translate('navigation.installation_services')}
              &nbsp;
              <i className="fa fa-chevron-down" />
            </div>

            <div className="dropdown-content">
              {!!isAdmin && (
                <Link
                    to={{
                      pathname: '/installationservice',
                      state: { installationDocumentId: null },
                    }}>
                  {translate('navigation.installationservice')}
                </Link>
              )}

              <Link to="/worklist">
                {translate('navigation.worklist')}
              </Link>
            </div>
          </div>
        ) : null }
        <Link to="/servicereport" className="navbar-item-inline navbar-nav-item">
          <span className="text-3">{translate('navigation.service_report')}</span>
        </Link>
      </div>
    );
  };

  userInfo = () => {
    const { translate } = this.props;
    const {
      session: {
        firstName,
        lastName,
      },
    } = this.props;
    return (
      <div key="navigation-user" className="col-md-3 col-xs-9">
        <div className="navbar-item-flex">
          <div className="navbar-item-flex navbar-nav-item">
            <img className="navbar-nav-icon"
                 src={userProfile}
                 alt="" />
            <span className="text-3">
              <div>{firstName}</div>
              <div>{lastName}</div>
            </span>
          </div>
          <Link to="/logout"
                className="navbar-item-flex navbar-nav-item">
            <img className="navbar-nav-icon navbar-nav-icon-logout"
                 src={userLogout}
                 alt={translate('navigation.log_out')} />
            <span className="text-3">
              {translate('navigation.log_out')}
            </span>
          </Link>
        </div>
      </div>
    );
  };

  languageDropDown = () => {
    const {
      translate,
      currentLanguage,
    } = this.props;

    const langs = ['fi', 'en'];
    return (
      <div key="navigation-lang" className="col-md-1 col-xs-3">
        <div className="dropdown">
          <div className="navbar-item-inline navbar-nav-item drop-button text-3">
            {translate('navigation.language')}
            &nbsp;
            <i className="fa fa-chevron-down" />
          </div>
          <div className="dropdown-content">
            {langs.map((it, idx) => (
              <button key={idx}
                      type="button"
                      className="btn-link language-selector text-left"
                      onClick={(e) => this.changeLanguage(e, it)}>
                {currentLanguage === it && (
                  <i className="fa fa-check" />
                )}
                {it.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  };

  createBottomBar = () => {
    const subNavbar = this.createSubBar();

    if (!subNavbar) {
      return null;
    }

    return (
      <nav className="navbar-bottom">
        <div className="container">
          <div className="row">
            {subNavbar}
          </div>
        </div>
      </nav>
    );
  };

  createSubBar() {
    const {
      subNavbar: {
        title,
        backLink,
        visible,
      } = {},
    } = this.props;

    if (!visible) {
      return null;
    }

    return (
      <div className="navbar-bottom-section vertical-middle">
        <Link className="navbar-sub-back" to={backLink}>
          <img className="navbar-sub-back-icon" src={backIcon} alt="navigate back" />
        </Link>
        <div className="navbar-sub-content">
          <div className="navbar-sub-half">
            {title[0]
              ? <h2>{title[0]}</h2>
              : null}
          </div>
          <div className="navbar-sub-half">
            {title[1]
              ? <h3>{title[1]}</h3>
              : null}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <header>
        {this.createTopBar()}
        {this.createBottomBar()}
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: state.locale ? getTranslate(state.locale) : () => '',
  subNavbar: state.navbar?.subNavbar || {},
  session: state.session.session || {},
  currentLanguage: state.locale
    ? (getActiveLanguage(state.locale) || {}).code || 'fi'
    : 'fi',
});

export default connect(
  mapStateToProps,
  null,
)(Navbar);
